//#region src/location_lock_owner.ts
let LocationLockOwner = /* @__PURE__ */ function(LocationLockOwner) {
	LocationLockOwner["MagicCopy"] = "magic-copy";
	LocationLockOwner["MenuAudit"] = "menu-audit";
	LocationLockOwner["PrecisionCopy"] = "precision-copy";
	LocationLockOwner["Quicksand"] = "quicksand";
	LocationLockOwner["RefreshMenuCache"] = "refresh-menu-cache";
	return LocationLockOwner;
}({});
//#endregion
export { LocationLockOwner };

//# sourceMappingURL=location_lock_owner.js.map